<template>
  <div >
    <div class="content-container">
        <SignupCard ref="signUpCard" @signup="onSignup" @sendVerificationCode="onSendVerificationCode" @gotoSignIn="handleGotoSignIn"
          :isSending="isSending" :isRegisting="isRegisting" />
    </div>
    <v-snackbar v-model="snackbar" :timeout="3000" top :color="level">
      {{ description }}
    </v-snackbar>
  </div>
</template>

<script>

// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
// Pubsub
import { publish } from "@/service/wd_pubsub.js";
import { signupPubIds } from '@/service/wd_pubsub_config.js';
//例如: import <组件名称> from  <组建路径>
import SignupCard from "./widgets/mv-card-signup.vue";
import { api_sendVerificationCode, api_AccountsSignUp, api_AccountsJoinCorporation } from "@/service/apiLogin.js";
import { userKeys, appIds } from "@/service/wd_app_config.js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    SignupCard,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      isSending: false,
      isRegisting: false,
      snackbar: false,
      level: "error",
      description: "",
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    handleGotoSignIn() {
      this.$emit("switchMode", "login");
    },
    onSendVerificationCode(params) {
      var that = this;
      that.isSending = true;
      const requestParams = {
        Usage: "1",
        AccountName: params.accountName,
        AccountType: params.loginType,
        RefreshVerificationCode: true,
        LcId: 1033
      }
      api_sendVerificationCode(requestParams).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleSendVerificationCode();
          } else {
            that.isSending = false;
            that.$message.error(response.data.Description)
          }
        },
        () => {
          that.isSending = false;
          that.$message.error(this.$i18n.t("ppt_add_in_main.server_general_error_message"))
        }
      );
    },
    handleSendVerificationCode() {
      this.isSending = false;
      this.$message.success(this.$i18n.t("signup.verification_code_send_success"));
      this.$refs.signUpCard.codeSendSuccess();
    },
    log(message, level = "error") {
      this.snackbar = true;
      this.level = level;
      this.description = message;
    },
    onSignup(params) {
      this.isRegisting = true;
      var that = this;
      api_AccountsSignUp(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleSignUp(response, params);
          } else {
            that.isRegisting = false;
            that.$message.error(response.data.Description);
          }
        },
        () => {
          that.isRegisting = false;
          that.$message.error(this.$i18n.t("ppt_add_in_main.server_general_error_message"))
        }
      );
    },
    handleSignUp(response, params) {
      localStorage.setItem(
        userKeys.key_globalAccessToken,
        response.data.Result.GlobalAccessToken
      );
      localStorage.setItem(
        userKeys.key_globalRefreshToken,
        response.data.Result.GlobalRefreshToken
      );
      // this.joinCorporation()
      this.handleRegisterUser(params);
    },
    joinCorporation() {
      // hardCode CorporationId: individal account in the one company:4db819d099b442bd0000000000000000
      // 这里的CorporationId是一个硬编码的值，实际应用中应该从后端获取'4db819d0-99b4-42bd-0000-000000000000'
      var that = this;
      const params = {
        corporationId: appIds.individual_corporation_id,
        globalAccessToken: localStorage.getItem(userKeys.key_globalAccessToken)
      }
      api_AccountsJoinCorporation(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleRegisterUser(response);
          } else {
            that.isRegisting = false;
            that.$message.error(response.data.Description);
          }
        },
        () => {
          that.isRegisting = false;
          that.$message.error(this.$i18n.t("ppt_add_in_main.server_general_error_message"))
        }
      );
    },
    handleRegisterUser(params) {
      this.isRegisting = false;
      this.$message.success(this.$i18n.t("signup.signup_success_show_user_msg"));
      // this.$router.replace("/welcome");
      publish(signupPubIds.pubId_Local_General_SignUpSuccess, 
      {
        success: true, 
        accountName: params.accountName, 
        password: params.password,
        loginType: params.loginType
      }
    );
    },
    handleGlobalGetUser(response) {
      localStorage.setItem(
        userKeys.key_userObject,
        JSON.stringify(response.data.result)
      );
      // 进入主页面
      this.$router.replace("/gpt");
      // var that = this;
      // if (response.data.result.Accounts.length > 0) {
      //   // 0: {Name: "qin@m2s.com", Type: 1, IsVerified: true}
      //   // 先不处理，只要有账号，继续往下进行
      //   var params = {
      //     globalAccessToken: localStorage.getItem(
      //       userKeys.key_globalAccessToken
      //     ),
      //   };
      //   wd_globalGetUserJoinStatus(params).then(
      //     (response) => {
      //       if (response.data.Code == 0) {
      //         that.handleGlobalGetUserJoinStatus(response);
      //       } else {
      //         that.isLoading = false;
      //         that.snackbar = true;
      //         that.description = response.data.Description;
      //       }
      //     },
      //     (error) => {
      //       that.isLoading = false;
      //       that.snackbar = true;
      //       that.description = error;
      //     }
      //   );
      // } else {
      //   that.isLoading = false;
      //   that.snackbar = true;
      //   that.description = response.data.Description;
      // }
    }
  }
};
</script>

<style scoped>
.content-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
